import React, {useState, createContext} from 'react';
import Header from '../../Header';
import Body from '../../Body';
import Footer from '../../Footer'

export const ThemeContext = createContext('');

const Dashboard = ({logout}:any): JSX.Element => {
    const [theme,setTheme] = useState('Dark Mode');
 
    const onThemeChanger = (e:React.ChangeEvent<HTMLInputElement>) => {
      if(e.target.checked){
        document.body.classList.add('darkTheme');
        document.body.classList.remove('lightTheme');
        setTheme('Dark Mode');
      }
      else {
        document.body.classList.add('lightTheme');
        document.body.classList.remove('darkTheme');
        setTheme('Light Mode');
      }
    }
    return <div className="containerWrapper">
      <Header theme={theme} onThemeChanger={onThemeChanger} logout={logout}/>
      <ThemeContext.Provider value={theme}>
        <Body/>
      </ThemeContext.Provider>
      <Footer/>
    </div>
}

export default Dashboard;